import { BarList } from "@/components/access-report/BarList";
import type { AccessReportSnapshot, AccessReportWaitBucket } from "@/lib/access-report";

const BUCKET_LABELS: Record<AccessReportWaitBucket, string> = {
  under_2w: "Under 2 weeks",
  w2_6: "2–6 weeks",
  w6_12: "6–12 weeks",
  over_3m: "Over 3 months",
  still_waiting: "Still waiting",
};

export function WaitReports({ data }: { data: AccessReportSnapshot }) {
  const usable = data.bySpecialty.filter((specialty) => specialty.waitReports !== null);

  if (usable.length === 0) {
    return (
      <p className="pb-access-suppression-note">
        n ≥ 3 not yet reached — {data.headline.waitReports.received} reports received
      </p>
    );
  }

  return (
    <div className="pb-access-wait-reports">
      {usable.map((specialty) => {
        const reports = specialty.waitReports;
        if (!reports) return null;
        return (
          <article key={specialty.specialty}>
            <header>
              <h3>{specialty.specialty}</h3>
              <span>n = {reports.n}</span>
            </header>
            <BarList
              items={Object.entries(reports.buckets).map(([bucket, value]) => ({
                label: BUCKET_LABELS[bucket as AccessReportWaitBucket],
                value,
              }))}
              total={reports.n}
              valueLabel="reports"
            />
            <p className="pb-access-outcome-line">
              Outcomes: {reports.outcomes.accepted} accepted · {reports.outcomes.declined} declined · {reports.outcomes.no_reply} no reply
            </p>
          </article>
        );
      })}
    </div>
  );
}
